<template lang="pug">
  .pix
    cp-card-info(
      iconName="alert"
      text="<strong>Ao efetuar o pagamento Pix, o seu pedido é automaticamente aprovado.</strong>"
    )

    div.pix__description
      h6.pix__description__title Rápido, prático e seguro:
      p.pix__description__text Clique em #[strong "Gerar código Pix"], você tem #[strong 24 horas] para confirmar o pagamento e assim que o mesmo for aprovado, a tela vai atualizar com o seu pedido confirmado.
</template>
<script>
import views from '@/mixins/views'

import cpCardInfo from '@/components/molecules/CardInfo.vue'

export default {
  name: 'Pix',
  mixins: [views],
  components: {
    cpCardInfo
  },
  mounted () {
    this.$emit('outinput', {
      installment: 1,
      isValid: true
    })
  }
}
</script>
<style lang="scss">
@import "@/assets/style/_variables";

  .pix {
    &__row {
      position: relative;
      width: 100%;

      @media screen and (min-width: 768px) {
        display: flex;
        justify-content: flex-start;
      }
    }

    &__description {
      color: #444444;
      margin-top: 32px;

      &__title {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 24px;
      }

      &__text {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
</style>
